import { render, staticRenderFns } from "./2Roues.vue?vue&type=template&id=024db9c4&scoped=true&"
import script from "./2Roues.vue?vue&type=script&lang=js&"
export * from "./2Roues.vue?vue&type=script&lang=js&"
import style0 from "./2Roues.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./2Roues.vue?vue&type=style&index=1&id=024db9c4&lang=scss&scoped=true&"
import style2 from "./2Roues.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024db9c4",
  null
  
)

export default component.exports